 $(document).ready(function () {
            $("#toggle-menu").click(function () {
                $(".mobile-menu").toggle();
            });
        });